import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo.png'
import _imports_1 from '@/assets/img/title.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-3058cbd2")

_pushScopeId("data-v-3058cbd2")
const _hoisted_1 = { class: "login" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "top-bar" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "logo",
  src: _imports_0
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  class: "logo",
  src: _imports_1
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("关于我们")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_el_header = _resolveComponent("el-header")
  const _component_router_view = _resolveComponent("router-view")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_footer = _resolveComponent("el-footer")
  const _component_el_container = _resolveComponent("el-container")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_container, null, {
      default: _withId(() => [
        _createVNode(_component_el_header, { height: "60px" }, {
          default: _withId(() => [
            _createVNode("span", null, [
              _hoisted_3,
              _createVNode(_component_router_link, { to: "main" }, {
                default: _withId(() => [
                  _hoisted_4
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_main, null, {
          default: _withId(() => [
            _createVNode(_component_router_view, null, {
              default: _withId(({ Component }) => [
                _createVNode(_Transition, { mode: "out-in" }, {
                  default: _withId(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_footer, null, {
          default: _withId(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
})